export var allowedRequiredFields = ['email'];
export var AllowedAdditionalEmailStatuses = ['pendingSubscription'];
//# sourceMappingURL=config.js.map